import type { IdentificacaoPedido } from "./pedidosManuais";
import type { RespostaWms } from "./rpc";

export interface Tarefa {
  id: string;
  local: string;
  local_tipo: string;
  produto_id: string;
  sku: string | null;
  nome: string;
  qtd_solicitada: number;
  qtd_coletada: number;
  qtd_falta: number;
  status: "pendente" | "concluida" | "falta" | "cancelada";
}

export interface PedidoOnda extends IdentificacaoPedido {
  id: string;
  numero: number | null;
  numero_ecommerce: string | null;
  canal: string | null;
  status: string;
  tags: string[];
  falta: boolean;
  ativo: boolean;
  montagem_aberta: boolean;
  contentor: string | null;
}

export interface ItemCarrinho {
  produto_id: string;
  sku: string | null;
  nome: string;
  quantidade: number;
}

/** Formas de separação (configuracoes.separacao_modos). */
export type ModoSeparacao = "onda_sku" | "onda_mista" | "pedido";

export interface ResumoOnda extends RespostaWms {
  abandonada?: boolean;
  onda: {
    id: string;
    numero: number;
    tipo: "MONO_SKU" | "MISTA";
    modo?: ModoSeparacao;
    status: "coletando" | "montando" | "concluida" | "cancelada";
    deposito_id: string;
    criado_em: string;
    produto: { id: string; sku: string | null; nome: string } | null;
    carrinho: string | null;
  };
  tarefas: Tarefa[];
  pedidos: PedidoOnda[];
  contagem: { tarefas_pendentes: number; pedidos: number; pedidos_montados: number; pedidos_pendentes: number };
  carrinho_itens: ItemCarrinho[];
  realocado?: number;
  sem_saldo?: number;
  ja_existia?: boolean;
}

export interface ItemMontagem {
  produto_id: string;
  sku: string | null;
  nome: string;
  esperada: number;
  bipada: number;
}

export interface DetalheMontagem extends RespostaWms {
  montagem: {
    id: string;
    status: string;
    onda_id: string;
    contentor: string | null;
    pedido: IdentificacaoPedido & { id: string; numero: number | null; numero_ecommerce: string | null; canal: string | null; tags: string[]; forma_envio: string | null };
  };
  itens: ItemMontagem[];
  completo: boolean;
  onda_concluida?: boolean;
  onda?: ResumoOnda;
  faltando?: Array<{ sku: string; nome: string; precisa: number; disponivel: number }>;
  pedido_id?: string;
}

/** Caixa de papelão sugerida pelo pedido (cadeira ligada à caixa em Cadastros, Embalagens). */
export interface EmbalagemSugerida {
  caixas: Array<{ embalagem_id: string; codigo: string | null; nome: string; quantidade: number;
                  comprimento_cm: number | null; largura_cm: number | null; altura_cm: number | null }>;
  produtos_sem_caixa: number;
}

export interface EstadoConferencia extends RespostaWms {
  conferencia_id: string;
  status: string;
  contentor: string | null;
  pedido: IdentificacaoPedido & { id: string; numero: number | null; numero_ecommerce: string | null; canal: string | null; forma_envio: string | null; tags: string[]; status: string };
  progresso: number;
  completo: boolean;
  embalagens: number;
  exigir_embalagem: boolean;
  embalagem_sugerida?: EmbalagemSugerida;
  imprimir_automatico: boolean;
  ocorrencias: number;
  tipo?: string;
  documentos?: Array<{ id: string; tipo: string; status: string }>;
}

export interface DocumentoImpressao {
  id: string;
  tipo: "DANFE_SIMPLIFICADO" | "ETIQUETA";
  status: string;
  erro: string | null;
  impresso_em: string | null;
  links: string[];
}

export const nomeDocumento: Record<string, string> = {
  DANFE_SIMPLIFICADO: "DANFE simplificado",
  ETIQUETA: "Etiqueta de transporte",
};
